import { useEmbeddedMode } from "@src/appV2/EmbeddedMode/EmbeddedModeContext";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { useHistory } from "react-router-dom";

import { useHasActionRequiredForMandatoryRequirements } from "../../Documents/api/useHasActionRequiredForMandatoryRequirements";
import { DOCUMENTS_BASE_PATH_FULL } from "../../Documents/paths";
import { AccountListItem } from "../components/AccountListItem";
import { logAccountPageMenuItemTapped } from "../utils";

export function AccountsPageDocumentsSection() {
  const { isEmbedded } = useEmbeddedMode();

  const history = useHistory();

  const hasActionRequiredForMandatoryRequirements = useHasActionRequiredForMandatoryRequirements();

  if (isEmbedded) {
    return null;
  }

  return (
    <AccountListItem
      iconType="folder"
      primaryText="Documents for Flex Shifts"
      secondaryText={
        <Text
          variant="caption"
          color={(theme) =>
            hasActionRequiredForMandatoryRequirements
              ? theme.palette.error.main
              : theme.palette.text.secondary
          }
        >
          {hasActionRequiredForMandatoryRequirements
            ? "Some documents are missing or expired!"
            : "Manage your documents"}
        </Text>
      }
      onClick={() => {
        logAccountPageMenuItemTapped("Documents");
        history.push(DOCUMENTS_BASE_PATH_FULL);
      }}
    />
  );
}
